import React from 'react'
// import { ManageCriteriaContainer } from '../../containers/SupportSystem/ManageCriteriaContainer'
import { ImportListMemberAnnounce4Container } from '../../containers/SupportSystem/ImportListMemberAnnounce4Container'
export const ImportListMemberAnnounce4Page = () => {
    return (
        <ImportListMemberAnnounce4Container />
    )
}
